import { expression } from "@mapbox/mapbox-gl-style-spec";
import { FeatureCollection } from "geojson";

export function filterFeatureCollection(featureCollection: FeatureCollection, filterExpression: any[]): FeatureCollection {
  const expr = expression.createExpression(filterExpression, { type: "boolean" });

  if (expr.result !== "success") {
    throw new Error(`Invalid filter: ${expr.value}`);
  }

  return {
    type: "FeatureCollection",
    features: featureCollection.features.filter((feature) => expr.value.evaluate({ zoom: 0 }, feature)),
  };
}
